import ActivatePage from "@components/ActivatePage.translations";

const components = {
  ActivatePage
};

export default components;
